import { FC } from 'react';
import Locale from '@app/form_components/Locale';

export const SettingsLocalePage: FC = () => {
  return (
    <div className="row">
      <div className="col-md-12">
        <Locale />
      </div>
    </div>
  );
};
